<template>
	<div v-if="display" class="row">
		<div class="col-md-12">
			<loading :active="loading">
				<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
			</loading>
			<table class="table table-hover table-striped table-condensed">
				<thead>
					<tr>
						<th>Importe</th>
						<th>Método de pago</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>
							<div class="form-group" :class="{ 'has-error' : errors.has('amount') }">
								<input
									v-validate="'required'"
									name="amount"
									data-vv-as="Importe"
									v-model="item.amount"
									type="number"
									class="form-control">
									<small v-show="errors.has('amount')" class="form-text text-danger">
										{{ errors.first('amount') }}
									</small>
							</div>
						</td>
						<td>
							<div class="form-group" :class="{ 'has-error' : errors.has('payment_method') }">
								<select
									v-validate="'required'"
									name="payment_method"
									data-vv-as="Método de pago"
									v-model="item.payment_method_id"
									class="form-control">
									<template v-if="payment_methods">
										<template v-if="payment_methods.length">
											<option v-for="method in payment_methods" :value="method.id">
												{{ method.name }}
											</option>
										</template>
									</template>
								</select>
								<small v-show="errors.has('payment_method')" class="form-text text-danger">
									{{ errors.first('payment_method') }}
								</small>
							</div>
						</td>
						<td>
							<div class="btn-group pull-right">
								<button :disabled="pending_payment < 0" @click="validate" type="button" class="btn btn-success">
									<i class="fa fa-floppy-o" aria-hidden="true"></i>
								</button>
								<button @click="close" type="button" class="btn btn-default">
									<i class="fa fa-times" aria-hidden="true"></i>
								</button>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import VueElementLoading from 'vue-element-loading'

	export default {
		props: ['user', 'isAuth', 'order', 'invoice', 'display', 'payment_methods', 'pending_payment'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				loading: false,
				item: {
					amount: null,
					order_id: (this.order) ? this.order.id : null,
					invoice_id: (this.invoice) ? this.invoice.id : null,
					payment_method_id: null,
				},
			}
		},
		watch: {
			'item.amount'() {
				this.item.amount = this.$options.filters.checkDecimals(this.item.amount)
				this.$emit('calculate', this.item)
			},
		},
		methods: {
			init() {
				this.getPayMentMethods()
			},
			close() {
				this.clearData()
				this.$emit('close')
			},
			clearData() {
				this.errors.clear()
				this.item.amount = null
				this.item.payment_method_id = null
			},
			getPayMentMethods() {
				this.$http.get('admin/management/payment/methods')
				.then(response => {
					this.payment_methods = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			validate() {
				var that = this
				if(this.pending_payment < 0) {
					return false
				}
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.store()
					}
					return result
				})
			},
			store() {
				this.loading = true
				this.$http.post('admin/management/partial/payments', this.item)
				.then(response => {
					this.$emit('reload')
					this.$emit('close')
					this.loading = false
					this.clearData()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
				})
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/partialPayments/views/Create.vue